import { REACT_APP_SERVER_DOMAIN } from "../base-env";

const TRACKING_API_BASE = `${REACT_APP_SERVER_DOMAIN}/chat`;

/**
 * Generates a simple pseudo-unique identifier.
 * This is sufficient for client-side session tracking.
 */
export const generatePseudoUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

interface TrackingStartInfo {
  conversationId: string;
  courseId: number | null;
  courseName: string | null;
  userName: string | null;
  userGroups: string[] | null;
  startTime: string;
}

/**
 * Starts tracking a new chat session.
 */
export const startChatTracking = async (startInfo: TrackingStartInfo) => {
  try {
    const response = await fetch(`${TRACKING_API_BASE}/start-tracking`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ 
        conversationId: startInfo.conversationId, 
        courseId: startInfo.courseId 
      })
    });

    // Intentionally silent on success or failure
  } catch (error) {
    // Intentionally silent on errors
  }
};

/**
 * Increments the user message count for the current session.
 */
export const incrementMessageCount = async (conversationId: string) => {
  try {
    const response = await fetch(`${TRACKING_API_BASE}/${conversationId}/increment-message`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    // Intentionally silent on non-OK response
  } catch (error) {
    // Intentionally silent on errors
  }
};


interface TrackingEndInfo {
  conversationId: string;
  userMessageCount: number;
  startTime: Date;
}

/**
 * Ends tracking for the current chat session.
 */
export const endChatTracking = async (endInfo: TrackingEndInfo) => {
  try {
    const endTime = new Date();
    const chatDurationMs = endTime.getTime() - endInfo.startTime.getTime();
    const chatDurationSeconds = Math.round(chatDurationMs / 1000);

    const response = await fetch(`${TRACKING_API_BASE}/${endInfo.conversationId}/end-tracking`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      keepalive: true // Essential for requests sent during page unload
    });

    // Intentionally silent on success or failure
  } catch (error) {
    // Intentionally silent on errors
  }
}; 